import React, { useContext } from 'react';
import { Select } from 'antd';
import { FlowEditorContext } from '../FlowEditor';

export default function NodeSelect({
  value,
  onChange,
  options,
  placeholder = 'Select next step...',
  style,
  allowClear = true,
  showSearch = true,
  ...rest
}) {
  const editor = useContext(FlowEditorContext);
  const nodeOptions = options || editor?.nodeOptions || [];

  const formattedOptions = nodeOptions.map((opt) => ({
    value: opt.value,
    title: opt.label,
    desc: opt.desc,
    label: (
      <div style={{ display: 'flex', flexDirection: 'column', padding: '2px 0' }}>
        <span style={{ fontWeight: 500, lineHeight: '1.4' }}>{opt.label}</span>
        {opt.desc ? (
          <span style={{ fontSize: 11, color: '#8c8c8c', lineHeight: '1.2', marginTop: 2 }}>
            {opt.desc}
          </span>
        ) : null}
      </div>
    ),
  }));

  return (
    <Select
      showSearch={showSearch}
      allowClear={allowClear}
      placeholder={placeholder}
      value={value || undefined}
      onChange={onChange}
      options={formattedOptions}
      optionLabelProp="title"
      filterOption={(input, option) => {
        const title = String(option?.title || '');
        const desc = String(option?.desc || '');
        return (
          title.toLowerCase().includes(input.toLowerCase()) ||
          desc.toLowerCase().includes(input.toLowerCase())
        );
      }}
      style={{ width: '100%', ...style }}
      {...rest}
    />
  );
}
